"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MobilePopover = ({ animation, children, title, onClose, navbarProps, hideNavBar = false, }) => {
    return (React.createElement("div", { style: {
            width: '100%',
            height: '100%',
            animation: `${animation === 'closing' ? 'close' : 'open'} 500ms ease`,
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 3,
            background: src_1.white,
        } },
        !hideNavBar && (React.createElement(src_1.NavBar, Object.assign({ buttonLeft: "Cancel", buttonLeftCallback: onClose, style: {
                buttonLeftStyle: {
                    outerStyle: {
                        marginLeft: 24,
                    },
                },
                buttonRightStyle: {
                    outerStyle: {
                        marginRight: 24,
                    },
                },
            } }, navbarProps))),
        title !== undefined && (React.createElement("div", { style: {
                padding: '24px 24px 0 24px',
            } },
            React.createElement(src_1.Text, { text: title, size: "h2" }))),
        children));
};
exports.default = MobilePopover;
